
import { URLS } from '../constants'
import {
    GET_CUSTOMER_BEGIN, GET_CUSTOMER_SUCCESS, GET_CUSTOMER_FAILURE,
    SET_COMPLETE_REGISTER_DATA,
    COMPLETE_REGISTER_BEGIN, COMPLETE_REGISTER_SUCCESS, COMPLETE_REGISTER_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost } from './ActionUtil'

// Get Customer
const acGetCustomerBegin = () => ({ type: GET_CUSTOMER_BEGIN })
const acGetCustomerSuccess = data => ({ type: GET_CUSTOMER_SUCCESS, payload: data })
const acGetCustomerFailure = err => ({ type: GET_CUSTOMER_FAILURE, payload: err })

/**
 * Fetches customer data from the server.
 *
 * @author Maria Eduarda Franke
 * @returns {Object} The dispatched action object.
 */
export const acGetCustomer = () => {
    return dispatchFetchGet(
        URLS.CUSTOMER,
        acGetCustomerBegin,
        acGetCustomerSuccess,
        acGetCustomerFailure
    )
}

// Complete Register
export const acSetCompleteRegisterData = data => ({ type: SET_COMPLETE_REGISTER_DATA, payload: data })

const acPostCompleteRegisterBegin = () => ({ type: COMPLETE_REGISTER_BEGIN })
const acPostCompleteRegisterSuccess = data => ({ type: COMPLETE_REGISTER_SUCCESS, payload: data })
const acPostCompleteRegisterFailure = err => ({ type: COMPLETE_REGISTER_FAILURE, payload: err })

/**
 * Function to complete the registration process for a customer.
 * 
 * @author Maria Eduarda Franke
 * @param {Object} params - The parameters for completing the registration.
 * @param {string} params.password - The password for the customer.
 * @param {string} params.firstName - The first name of the customer.
 * @param {string} params.lastName - The last name of the customer.
 * @param {string} params.phone - The phone number of the customer.
 * @param {string} params.plan - The plan for the customer.
 * 
 * @returns {Promise} A promise that resolves when the registration is complete.
 * 
 * @throws {Error} If there is an error during the registration process.
 */
export const acPostCompleteRegister = ({ password, firstName, lastName, phone, plan }) => {
    return dispatchFetchPost(
        URLS.COMPLETE_REGISTER,
        { password, firstName, lastName, phone, plan },
        acPostCompleteRegisterBegin,
        acPostCompleteRegisterSuccess,
        acPostCompleteRegisterFailure
    )
}